import { getAutoScroll, setAutoScroll } from "../state/autoScroll";

export default function disableAutoScroll() {
	if (getAutoScroll()) {
		setAutoScroll(false);

		return true;
	}
}
